<template>
  <a-form :form="form" id="form">
    <a-row :gutter="16">
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-form-item label="Product Specifications">
          <a-select
            placeholder="Select Product Specifications"
            v-decorator="['spesifikasi_produk', {rules: [{required: true}], initialValue : initialData.spesifikasi_produk}]"
          >
            <a-select-option
              v-for="item in getSpesifikasiProduk"
              :key="item.value"
            >{{item.text}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Certificate QMS">
          <a-select
            showSearch
            placeholder="Select Certificate QMS"
            v-decorator="['sertifikat_qms', {rules: [{required: true}], initialValue : initialData.sertifikat_qms}]"
          >
            <a-select-option v-for="item in getSertifikatQms" :key="item.value">{{item.text}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-form-item label="Business Certificate">
          <a-select
            showSearch
            placeholder="Select Business Certificate"
            v-decorator="['sertifikat_usaha', {rules: [{required: true}], initialValue : initialData.sertifikat_usaha}]"
          >
            <a-select-option v-for="item in getSertifikatUsaha" :key="item.value">{{item.text}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Risk analysis">
          <a-select
            showSearch
            placeholder="Select Risk analysis"
            v-decorator="['analisis_resiko', {rules: [{required: true}], initialValue : initialData.analisis_resiko}]"
          >
            <a-select-option v-for="item in getAnalisaResiko" :key="item.value">{{item.text}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "KriteriaSeleksi",
  props: {
    data: {},
    mode: String
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getSpesifikasiProduk",
      "getSertifikatQms",
      "getSertifikatUsaha",
      "getAnalisaResiko"
    ]),
    initialData() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          spesifikasi_produk: "",
          sertifikat_qms: "",
          sertifikat_usaha: "",
          analisis_resiko: ""
        };
      } else {
        return {
          spesifikasi_produk: this.data.spesifikasi_produk,
          sertifikat_qms: this.data.sertifikat_qms,
          sertifikat_usaha: this.data.sertifikat_usaha,
          analisis_resiko: this.data.analisis_resiko
        };
      }
    }
  },
  created() {
    this.$store.dispatch("Fetch_Spesifikasi_Produk");
    this.$store.dispatch("Fetch_Sertifikat_Qms");
    this.$store.dispatch("Fetch_Sertifikat_Usaha");
    this.$store.dispatch("Fetch_Analisa_Resiko");
  },
  methods: {
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          console.log(err);
          this.displayMessage("form-warning");
          return;
        }
        Event.$emit("purchasingData", { kriteria: values });
      });
    }
  }
};
</script>

<style>
</style>